import React from 'react';
import ReactModal from 'react-modal';

import { Size } from 'coreOld/enums';

import { ModalDialogWrapper, ModalStyle, OverlayStyle } from './modalHorizontalDialogStyle';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode | React.ReactNode[];
  size?: Size;
  height?: number;
  minWidth?: number | string;
  shouldCloseOnOverlayClick?: boolean;
  parentSelector?: () => HTMLElement;
  borderColor?: string;
}

const getMaxWidthFromSize = (size: Size) => {
  switch (size) {
    case Size.SM:
      return 320;
    case Size.MD:
      return 520;
    case Size.LG:
      return 720;
    case Size.XL:
      return 900;
    case Size.FULL_WIDTH:
      return '100vw';
    default:
      return null;
  }
};

const ModalHorizontalDialogView = ({
  isOpen,
  onClose,
  children,
  size = Size.FULL_WIDTH,
  height,
  minWidth,
  shouldCloseOnOverlayClick = false,
  parentSelector,
  borderColor,
}: IProps) => {
  return (
    <ReactModal
      closeTimeoutMS={500}
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      className="_"
      overlayClassName="_"
      contentElement={(props, children) => (
        <ModalStyle {...{ ...props, height, borderColor }}>{children}</ModalStyle>
      )}
      overlayElement={(props, contentElement) => (
        <OverlayStyle {...props}>{contentElement}</OverlayStyle>
      )}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      parentSelector={parentSelector}
    >
      <ModalDialogWrapper
        style={{
          height: height,
          minWidth: minWidth || getMaxWidthFromSize(size),
          maxWidth: getMaxWidthFromSize(size),
        }}
      >
        {children}
      </ModalDialogWrapper>
    </ReactModal>
  );
};

export default ModalHorizontalDialogView;
